import { render, staticRenderFns } from "./BaseDataPanel.vue?vue&type=template&id=ee22b840&scoped=true&"
import script from "./BaseDataPanel.vue?vue&type=script&lang=js&"
export * from "./BaseDataPanel.vue?vue&type=script&lang=js&"
import style0 from "./BaseDataPanel.vue?vue&type=style&index=0&id=ee22b840&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee22b840",
  null
  
)

export default component.exports